import Marquee from "react-fast-marquee";

const WORDS = ["FURNACES", "AIR CONDITIONING", "HEAT PUMPS", "GAS INSERTS", "MAINTENANCE", "REPAIRS"];

export const MarqueeStrip = () => {
  return (
    <div className="border-y border-white/10 bg-background py-6 md:py-8">
      <Marquee speed={55} gradient={false} autoFill>
        {WORDS.map((w, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display text-4xl uppercase tracking-tight text-stroke md:text-6xl">
              {w}
            </span>
            <span className="mx-8 text-primary md:mx-12">✳</span>
          </div>
        ))}
      </Marquee>
    </div>
  );
};
